// CreateSubscriptionResult.tsx
import React from 'react';
import {Alert} from '@material-ui/lab';
import JsonRenderComponent from "../../../../../../utils/JsonRenderComponent";

interface CreateSubscriptionResultProps {
    resultSuccessful: boolean;
    response: any;
}

const CreateSubscriptionResult: React.FC<CreateSubscriptionResultProps> = ({
                                                                               resultSuccessful,
                                                                               response
                                                                           }) => {
    return (
        <div>
            <p>
                {resultSuccessful ? (
                    <Alert severity="success">
                        Successfully retrieved cached pharmacy customer
                    </Alert>
                ) : (
                    <Alert severity="error">
                        Failed to retrieve cached pharmacy customer
                    </Alert>
                )}
            </p>
            {response && (
                <div style={{
                    border: '1px solid #ccc',
                    padding: '10px',
                    marginTop: '10px'
                }}>
                    <JsonRenderComponent
                        jsonObject={response}
                        printHtml={false}
                    />
                </div>
            )}
        </div>
    );
};

export default CreateSubscriptionResult;
